import {Controller} from "stimulus"
import $ from 'jquery';

function resultTemplate(row) {
    if(!row.text){
        return 'Seleccione una opción';
    }
    return  `Referencia: ${row.text} - Cliente: ${row.client_name} ${row.client_lastname} `;
}
function resultRow(row) {
    let external = ''
    if( row.external){
       external = '(<span style="font-size: .7rem; color: #d43f34">EXTERNO</span>)'
    }

    return  $(`<div class="row justify-content-start py-3">
                <div class="col-md-6">Referencia: ${row.text} ${external}</div>
                <div class="col-md-6">Cliente: ${row.client_name} ${row.client_lastname}</div>
            </div> 
            <div class="row justify-content-start">
                <div class="col-md-4" style="font-size: .8rem;">Producto: ${row.product}</div>
                <div class="col-md-4" style="font-size: .8rem;">Desde: ${row.from} </div>
                <div class="col-md-" style="font-size: .8rem;">Hasta: ${row.to}</div>
            </div>` );
}

function resultTemplateVehicle(row) {
    if(!row.text){
        return 'Seleccione una opción';
    }
    let model = ``
    if(row.make && row.model){
        model = `- Modelo: ${row.make} ${row.model}`
    }
    return  `Chapa: ${row.text}  ${model}`;
}
function resultRowVehicle(row) {
    return  $(`<div class="row justify-content-start py-3">
                <div class="col-md-6">Referencia: ${row.text}</div>
                <div class="col-md-6">Cliente: ${row.make} ${row.model}</div>
            </div>` );
}

export default class extends Controller {
    static targets = [ 'voucher', 'autorizedVehicle']
    connect() {
      if(this.hasVoucherTarget){
        let vouchers = $(this.voucherTarget)
          let conditioning = true
          if(this.voucherTarget.dataset.hasOwnProperty('type')  && (this.voucherTarget.dataset.type === 'atv' || this.voucherTarget.dataset.type === 'ticket')){
              conditioning = false
          }
          vouchers.select2({
              theme: "bootstrap",
              language: "es",
              placeholder: "Seleccione una opción",
              minimumInputLength: 10,
              templateResult: resultRow,
              templateSelection: resultTemplate,
              ajax: {
                  url: `${location.origin}/admin/histories/vouchers`,
                  dataType: "json",
                  language: "es",
                  data: function (params) {
                      return {
                          no_reference: params.term,
                          offset: params.page || 0,
                          limit: 10,
                          conditioning: conditioning
                      }

                  },
                  type: 'GET',
                  processResults: function (data, params) {
                      let result = [];
                      params.page = params.page || 0;

                      data.rows.map((elem, key) => {
                          result.push({
                              id: elem.id+"|"+elem.external,
                              text: elem.references,
                              client_name: elem.client_name,
                              client_lastname: elem.client_lastname,
                              product: elem.product,
                              from: elem.from,
                              to: elem.to,
                              external: elem.external

                          })
                      })

                      if (data.total > 10) {

                          if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                              return {
                                  results: result,
                                  "pagination": {
                                      "more": true
                                  }
                              }
                          } else {
                              return {
                                  results: result,
                                  "pagination": {
                                      "more": false
                                  }
                              }
                          }

                      } else {
                          return {
                              results: result,
                              "pagination": {
                                  "more": false
                              }
                          }
                      }
                  }
              }

          })
      }
      if(this.hasAutorizedVehicleTarget){
          let autorized_vehicle = $(this.autorizedVehicleTarget)
          autorized_vehicle.select2({
              theme: "bootstrap",
              language: "es",
              placeholder: "Seleccione una opción",
              minimumInputLength: 4,
              templateResult: resultRowVehicle,
              templateSelection: resultTemplateVehicle,
              ajax: {
                  url: `${location.origin}/admin/vehicles/data_for_select`,
                  dataType: "json",
                  language: "es",
                  data: function (params) {
                      return {
                          search: params.term.trim(),
                          offset: params.page || 0,
                          limit: 10,
                          active: true
                      }

                  },
                  type: 'GET',
                  processResults: function (data, params) {
                      let result = [];
                      params.page = params.page || 0;

                      data.rows.map((elem, key) => {
                          result.push({
                              id: elem.id,
                              text: elem.registration,
                              make: elem.make,
                              model: elem.model

                          })
                      })

                      if (data.total > 10) {

                          if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                              return {
                                  results: result,
                                  "pagination": {
                                      "more": true
                                  }
                              }
                          } else {
                              return {
                                  results: result,
                                  "pagination": {
                                      "more": false
                                  }
                              }
                          }

                      } else {
                          return {
                              results: result,
                              "pagination": {
                                  "more": false
                              }
                          }
                      }
                  }
              }

          })

      }
    }
}